import {gsap} from "gsap";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

/**
 * Created by jonas on 2021-03-31.
 */

export class MechanicalCounterWheel extends PIXI.Container {
    private stepSize: number;
    private _numbers: PIXI.Sprite;
    private _numbers2: PIXI.Sprite | undefined;
    private mode: MechanicalCounterMode;
    private value: number = 0;


    constructor(numbers: PIXI.Sprite, mode: MechanicalCounterMode) {
        super();
        this.mode = mode;
        this._numbers = numbers;

        if (mode != MechanicalCounterMode.DIRECT) {
            this._numbers2 = new PIXI.Sprite(numbers.texture);
            this._numbers2.y = this._numbers.y + this._numbers.height;
            this.addChild(this._numbers2);
        }

        this.addChild(this._numbers);
        this.stepSize = numbers.height / 10;
        this.setValue(0);

    }

    public setValue(value: number, duration: number = 0): gsap.core.Animation {
        let anim;
        switch (this.mode) {
            case MechanicalCounterMode.DIRECT:
                anim = this.setValueDirect(value, duration);
                break;
            case MechanicalCounterMode.REPEAT:
                anim = this.setValueUp(value, duration);
                break;
        }

        this.value = value;
        return anim;
    }


    private setValueDirect(value: number, duration: number = 0): gsap.core.Animation {
        if (duration > 0) {
            return gsap.to(this._numbers, {duration: duration, y: value * -this.stepSize, ease: "power3.in"});
        }
        return gsap.set(this._numbers, {duration: duration, y: value * -this.stepSize, ease: "power3.in"});
    }


    private setValueUp(value: number, duration: number = 0): gsap.core.Animation {

        let steps = value - this.value;
        if (steps < 0) {
            steps += 10;
        }

        const tl: gsap.core.Timeline = gsap.timeline();


        this._numbers2!.y = this._numbers.y + this._numbers.height;

        const target: number = this._numbers.y - (steps * this.stepSize);
        const target2: number = this._numbers2!.y - (steps * this.stepSize);
        tl.add([
            gsap.to(this._numbers, {duration: duration, y: target, ease: "power3.in"}),
            gsap.to(this._numbers2!, {duration: duration, y: target2, ease: "power3.in"}),
        ]);

        tl.add(() => {
            this._numbers.y = value * -this.stepSize;
            this._numbers2!.y = this._numbers.y + this._numbers.height;
        });


        return tl;
    }

}


export interface MechanicalCounterTextureSet {
    // background:PIXI.Texture;
    numbers: PIXI.Texture;
    // overlay:PIXI.Texture;
}

export enum MechanicalCounterMode {
    DIRECT = "DIRECT",
    REPEAT = "REPEAT"
}

export class MechanicalCounter extends PIXI.Container {
    private _wheels: MechanicalCounterWheel[] = [];
    public currentValue: number = 0;

    constructor(wheelsCount: number, textures: MechanicalCounterTextureSet, spacing: number, mode: MechanicalCounterMode = MechanicalCounterMode.DIRECT) {
        super();

        for (let i: number = 0; i < wheelsCount; i++) {
            const wheel = new MechanicalCounterWheel(
                new PIXI.Sprite(textures.numbers),
                mode
            );
            wheel.position.set(i * spacing, 0);
            this.addChild(wheel);
            this._wheels.push(wheel);
        }
        let mask = new PIXI.Graphics();
        mask.beginFill();
        mask.drawRect(0, 0, 117, 25);
        this.mask = mask;
        this.addChild(mask);
    }

    public setValue(value: number): gsap.core.Timeline {

        const valueArray = value.toString().split("");

        if (valueArray.length > this._wheels.length) {
            Logger.warn("Not enough wheels in this counter");
        }
        const tl: gsap.core.Timeline = gsap.timeline();

        if (value == this.currentValue) {
            return tl;
        }

        this.currentValue = value;
        for (let i: number = this._wheels.length - 1; i >= 0; i--) {
            const value = valueArray.pop();
            const number = value == undefined ? 0 : parseInt(value);
            tl.add(this._wheels[i].setValue(number, 0.3), "<0.1");
        }

        return tl;
    }

}
